// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"919438a57e8b22fd07b0","258":"26e5196250c5be151ef3"}[chunkId] + ".js");